/* Connecting tailwind css styles */
import './assets/scss/main.scss';
import './assets/css/main.css';

export default {
  install() {},
};
